/** The header's Feedback item and the panel under it (spec §6.4). Not a modal, no fanfare:
 * a beta tester says something in two clicks and carries on where they were. */
import { useState } from "react";
import type { Api } from "../api/api";
import { brand } from "../brand";
import "../styles/feedback.css";

type Props = {
  api: Api;
  path: string;
  /** Controlled by the header, so the account menu's Feedback item can open it too. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
};

export function FeedbackPanel({ api, path, open: controlled, onOpenChange }: Props) {
  const [own, setOwn] = useState(false);
  const open = controlled ?? own;
  const setOpen = (o: boolean) => {
    setOwn(o);
    onOpenChange?.(o);
  };
  const [text, setText] = useState("");
  const [broke, setBroke] = useState(false);
  const [state, setState] = useState<"idle" | "busy" | "sent" | "failed">("idle");

  async function send() {
    setState("busy");
    const r = await api.sendFeedback({ kind: "general", body: text.trim(), broke, path });
    setState(r.ok ? "sent" : "failed");
    if (r.ok) {
      setText("");
      setBroke(false);
    }
  }

  return (
    <>
      <button
        type="button"
        className="bar__link"
        aria-expanded={open}
        onClick={() => {
          setOpen(!open);
          setState("idle");
        }}
      >
        Feedback
      </button>
      {open && (
        <div className="feedback" role="region" aria-label="Feedback">
          {state === "sent" ? (
            <p className="muted">Thanks — read by a person.</p>
          ) : (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                void send();
              }}
            >
              <label>
                What happened, or what you think
                <textarea
                  value={text}
                  onChange={(e) => setText(e.target.value)}
                  rows={3}
                  maxLength={4000}
                />
              </label>
              <label className="check">
                <input
                  type="checkbox"
                  checked={broke}
                  onChange={(e) => setBroke(e.target.checked)}
                />{" "}
                Something broke
              </label>
              <div className="feedback__send">
                <span className="muted">Read by a person.</span>
                <button
                  className="button button--primary"
                  disabled={state === "busy" || !text.trim()}
                >
                  Send
                </button>
              </div>
              {state === "failed" && (
                <p role="alert">That did not send. Try again, or write to {brand.supportEmail}.</p>
              )}
            </form>
          )}
        </div>
      )}
    </>
  );
}
